import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ADMIN_QUERY_DEFAULTS } from "./lib/query-client";
import "./assets/styles/index.css";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: ADMIN_QUERY_DEFAULTS,
	},
});

const root = document.getElementById("root");
if (!root) {
	throw new Error("Missing root element");
}

ReactDOM.createRoot(root).render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<App />
		</QueryClientProvider>
	</React.StrictMode>,
);
